/** ----------------------------------------
    IBAN
---------------------------------------- */

import { Validator } from 'vee-validate';

Validator.extend('minimal_age', {
    validate (value, test) {
        return value === test[0];
    },
    getMessage (field) {
        return `You do not meet the minimum age requirement`;
    }
});